import * as React from 'react';
import { NextPage } from 'next';
import { NextSeo, NextSeoProps } from 'next-seo';

import { ISlice } from '@types';

import Page from './Page';
import { IProject, IProjects } from './types';

export interface ViewProps {
  params: { slug: string };
  project: IProject;
  projects: IProjects[];
  slices: ISlice[];
  seo: NextSeoProps | null;
}

const View: NextPage<ViewProps> = ({
  project,
  projects,
  slices,
  seo,
  params: { slug },
}) => (
  <>
    <NextSeo {...seo} />
    <Page project={project} projects={projects} slices={slices} />
  </>
);

View.displayName = 'ProjectView';

export default View;
